var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgU = function SvgU(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.005,
    height: 45,
    viewBox: "0 0 39.005 44.213"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2 43.2h-8.1a1.11 1.11 0 0 1-1.1-1.1v-5.9h-.2a16.676 16.676 0 0 1-4.6 5.6c-2.1 1.6-4.9 2.4-8.5 2.4a16.683 16.683 0 0 1-7.3-1.4A14.091 14.091 0 0 1 3.5 39a13.752 13.752 0 0 1-2.7-5.4 27.362 27.362 0 0 1-.8-6.4V1.1A1.11 1.11 0 0 1 1.1 0h8.6a.987.987 0 0 1 1 .9v21c0 1.2.1 2.5.2 4a14.328 14.328 0 0 0 .9 4.1 7.546 7.546 0 0 0 2.3 3.2 6.917 6.917 0 0 0 4.4 1.3 11.661 11.661 0 0 0 4.5-.9 8.745 8.745 0 0 0 4.7-5.9 13.974 13.974 0 0 0 .5-4.1V1.1a1.09 1.09 0 0 1 1-1.1h8.6a.987.987 0 0 1 1 .9v41.2c.5.6 0 1.1-.6 1.1",
    fill: "#fff"
  })));
};

export default SvgU;